import {
  HOME_ROUTE,
  ONBOARDING_KYC_ROUTE,
  ONBOARDING_SUITABILITY_ROUTE,
  ONBOARDING_CREATE_ACCOUNT_ROUTE,
  ONBOARDING_FUNDING_ROUTE,
} from "_constants";

export const ONBOARDING_BLOCKED = "ONBOARDING_BLOCKED";

export const getOnboardingStepRoute = (details) => {
  const lastStep = `${details?.lastStep || ""}`.toUpperCase();
  const kycStatus = `${details?.kycDocumentStatus || ""}`.toUpperCase();
  const documentUpload = `${details?.documentUpload || ""}`.toUpperCase();
  const suitability = `${details?.suitabilityCheck || ""}`.toUpperCase();
  const createAccount = `${details?.createTradingAccount || ""}`.toUpperCase();

  if (kycStatus === "PENDING_UPLOAD" || kycStatus === "ERROR_IN_VERIFICATION") {
     
    return ONBOARDING_KYC_ROUTE;
 
  }

  if (kycStatus === "BLOCKED") {
    return ONBOARDING_BLOCKED;
  }

  if (kycStatus === "ONGOING_VERIFICATION") {
    if (documentUpload !== "SUCCESS") return ONBOARDING_KYC_ROUTE;
    if (suitability !== "SUCCESS") return ONBOARDING_SUITABILITY_ROUTE;
    if (createAccount !== "SUCCESS") return ONBOARDING_CREATE_ACCOUNT_ROUTE;
    return ONBOARDING_FUNDING_ROUTE;
  }

  if (kycStatus === "VERIFIED_SUCCESSFULLY" && documentUpload === "SUCCESS") {
    if (createAccount !== "SUCCESS") {
      if (suitability === "SUCCESS") return ONBOARDING_CREATE_ACCOUNT_ROUTE;
      return ONBOARDING_SUITABILITY_ROUTE;
    }

    if (lastStep === "CREATE_ACCOUNT") return ONBOARDING_FUNDING_ROUTE;

    if (lastStep === "APPROVED_NOT_FUNDED") {
      
      if (suitability === "PENDING") return ONBOARDING_SUITABILITY_ROUTE;
      if (createAccount === "PENDING") return ONBOARDING_CREATE_ACCOUNT_ROUTE;
      return ONBOARDING_FUNDING_ROUTE;
    }

    if (lastStep === "FTD" || lastStep === "RDP") return HOME_ROUTE;
  }

  return ONBOARDING_KYC_ROUTE;
};
